var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          attrs: {
            id: "no-connection",
            "data-backdrop": "static",
            "data-keyboard": "false",
          },
        },
        [
          _c(
            "a-modal",
            {
              staticClass: "modal-dialog",
              attrs: {
                visible: true,
                id: "no-connection-amodal",
                wrapClassName: "vertical-center-modal",
              },
            },
            [
              _c("span", { staticClass: "loader" }),
              _vm._v(" "),
              _c("p", { staticClass: "noConnectionText" }, [
                _vm._v(_vm._s(_vm.$t("message.noConnection"))),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }